import React from "react";
import CustomMeta from "../components/CustomMeta/CustomMeta";

// Components
import FeedbackButton from "../components/FeedbackButton/FeedbackButton";

// MUI stuff
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { makeStyles } from "tss-react/mui";
import Link from "@mui/material/Link";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  paper: {
    margin: 20,
    padding: 20,
  },
  contactDetails: {
    display: "block",
  },
  innerText: {
    padding: 20,
  },
  contactDivider: {
    margin: 20,
  },
  contactDetailsDiv: {
    textAlign: "center",
  },
}));

function contact() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Contact Content Generator | Support & Help`}
        description={`Get in touch with Content Generator's support team for h elp with social media marketing tools, custom post creation, and technical assistance. We're here to help you succeed with your social media marketing strategy.`}
        url={`https://contentgenerator.io/contact`}
      />
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h5">
          Contact us
        </Typography>
        <div className={classes.contactDetailsDiv}>
          <Typography className={classes.contactDetails}>
            Email:{" "}
            <Link href="mailto:info@contentgenerator.io" underline="hover">
              info@contentgenerator.io
            </Link>
          </Typography>
          <Typography className={classes.contactDetails}>
            Twitter:{" "}
            <Link
              href="https://twitter.com/OliverBoyers"
              target="_blank"
              underline="hover"
            >
              @OliverBoyers
            </Link>
          </Typography>
          <FeedbackButton />
        </div>
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(contact);
